export default __webpack_public_path__ + "static/media/third_place.7e61da7b.svg";